<template>
  <div class="box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <div class="viewFilter">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="cpf" label="CPF">
              <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.cpf" v-mask="['###.###.###-##']" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="business_cnpj" label="CNPJ">
              <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.business_cnpj" v-mask="['##.###.###/####-##']" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="name" label="Nome">
              <el-input masked="true" :autofocus="true" size="large" v-model="ruleForm.name" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="marketplace_id" label="Marketplace">
              <SelectSearchMarketplace :disabled="$can('2|4|5')" :model="ruleForm.marketplace_id" :isEdit="false" @handleValue=" (x) => { ruleForm.marketplace_id = x } "  />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="status" label="Status">
              <el-select v-model="ruleForm.status" clearable style="width: 100%;">
                <el-option value="new" label="Novo"/>
                <el-option value="risk_analysis" label="Em Analise de Risco"/>
                <el-option value="risk_analysis_error" label="Erro na Analise de Risco"/>
                <el-option value="risk_analysis_reproved" label="Analise de Risco Reprovada"/>
                <el-option value="risk_analysis_manually" label="Analise Manual"/>
                <el-option value="risk_analysis_approved" label="Analise de Risco Aprovada"/>
                <el-option value="pending" label="Pendente"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="periodo_analise" label="Período da Análise">
              <el-date-picker
                format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                style="width: 100%"
                v-model="ruleForm.periodo_analise"
                type="daterange"
                start-placeholder="Inicio" end-placeholder="Fim">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="periodo_cadastro" label="Período do Cadastro">
              <el-date-picker
                format="dd/MM/yyyy" value-format="yyyy-MM-dd"
                style="width: 100%"
                v-model="ruleForm.periodo_cadastro"
                type="daterange"
                start-placeholder="Inicio" end-placeholder="Fim">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
              <el-button icon="el-icon-download" @click='searchTable(true)' type="default" size="large" style="float: right; margin-right: 20px">
              Exportar 
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch()' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
  
<script>
  import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
  import {mapGetters} from "vuex";

  export default {
    name: "FilterBox",
    components: {
      SelectSearchMarketplace,
    },
    data () {
      return {
        loadingPage: true,
        query:`?page=${this.currentPage}`,
        cityOptions: [],
        StateOptions: [],
        ruleForm: {
          searchInput: '',
          type_person: null,
          cpf: null,
          business_cnpj: null,
          agent_id: null,
          marketplace_id: null,
        },
        viewFilter: false,
        loadingCity: false,
      }
    },
    props: {
      currentPage: {
        type: Number,
        default: 1
      },
      type: {
        type: Number,
        default: 0
      }
    },
    computed: {
      ...mapGetters('Auth', ['currentUser']),
      statusClearFilter: function () {
        if (this.ruleForm.searchInput || this.ruleForm.type_person || this.ruleForm.cpf || this.ruleForm.business_cnpj || this.ruleForm.agent_id || this.ruleForm.marketplace_id) {
          return true
        }
        return false
      }
    },
    methods: {
      clearSearch () {
        this.viewFilter = false
        this.ruleForm = {
          cpf: null,
          business_cnpj: null,
          name: null,
          marketplace_id: null,
          status: null,
          periodo_analise: null,
          periodo_cadastro: null,
        }
        this.$emit('filter', `?page=${this.currentPage}`)
        this.query = '?page=${this.currentPage}';
      },
      searchTable (ex) {
        this.query = `?page=${this.currentPage}`;
        if (this.ruleForm.cpf) {
          this.query = `${this.query}&cpf=${this.ruleForm.cpf.replace(/[^\d]+/g, '')}`
        }
        if (this.ruleForm.business_cnpj) {
          this.query = `${this.query}&business_cnpj=${this.ruleForm.business_cnpj.replace(/[^\d]+/g, '')}`
        }
        if (this.ruleForm.name) {
          this.query = `${this.query}&name=${this.ruleForm.name}`
        }
        if (this.ruleForm.marketplace_id) {
          this.query = `${this.query}&marketplace_id=${this.ruleForm.marketplace_id}`
        }
        if (this.ruleForm.status) {
          this.query = `${this.query}&status=${this.ruleForm.status}`
        }
        if (this.ruleForm.periodo_analise) {
          this.query = `${this.query}&periodo_analise=${this.ruleForm.periodo_analise}`
        }
        if (this.ruleForm.periodo_cadastro) {
          this.query = `${this.query}&periodo_cadastro=${this.ruleForm.periodo_cadastro}`
        }
        if (ex) {
          this.$emit('filterExport', this.query)
        } else {
          this.$emit('filter', this.query)
        }
      },
  
    },
    async mounted() {
      if (this.$can('2|4|5')) {
        this.ruleForm.marketplace_id = this.currentUser.marketplace_id
      }
      if (this.$can('4')) {
        this.ruleForm.agent_id = this.currentUser.agent_id
      }
      if (this.$can('5')) {
        this.$set(this.ruleForm, 'department_store_id', this.currentUser.department_store_id)
        this.ruleForm.department_store_id = this.currentUser.department_store_id
  
        this.$set(this.ruleForm, 'marketplace_id', this.currentUser.department_store.marketplace_id)
        this.ruleForm.marketplace_id = this.currentUser.department_store.marketplace_id
  
        this.$set(this.ruleForm, 'agent_id', this.currentUser.department_store.agent_id)
        this.ruleForm.agent_id = this.currentUser.department_store.agent_id
      }
    }
  }
</script>

<style scoped>

</style>
  